import React from 'react';

const Testimonials = () => {
  const testimonials = [
    {
      quote: 'Harish consistently delivers pixel-perfect, high-quality work that exceeds expectations. His attention to detail and technical expertise make him an invaluable team member.',
      author: 'Mohammed Abdul Hafeez',
      role: 'Engineering Manager, IBM'
    },
    {
      quote: 'Harish improves team velocity and code quality through thoughtful architecture decisions and mentorship. He\'s always willing to help and share knowledge.',
      author: 'Reshma Patan',
      role: 'Senior Frontend Engineer, IBM'
    },
    {
      quote: 'Working with Harish transformed our user experience. His React expertise and performance optimizations resulted in measurable improvements in user engagement.',
      author: 'Gireesha',
      role: 'Product Manager, IBM'
    }
  ];

  return (
    <section id="testimonials" className="testimonials-section">
      <div className="testimonials-container">
        <div className="section-header">
          <h2 className="section-title">Testimonials</h2>
          <p className="section-subtitle">
            What colleagues and clients say about working with me
          </p>
        </div>

        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <blockquote className="testimonial-quote">
                <span className="quote-mark">"</span>
                <p>{testimonial.quote}</p>
              </blockquote>
              <div className="testimonial-author">
                <span className="author-name">{testimonial.author}</span>
                <span className="author-role">{testimonial.role}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;

